import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  form: any = {};
  submitted: any;
  show_button: boolean = false;
  show_eye: boolean = false;
  showErrorMessages!: string;

  requires2FA: boolean = false;
  totpCode: string = '';

  constructor(
    private spinner: NgxSpinnerService,
    private route: Router,
    public service: ApiService,
    private toastr: ToastrService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    const savedLang = localStorage.getItem('hit2open_lang') || 'en';
    this.translateService.use(savedLang);
  }

  get currentLang(): string {
    return this.translateService.currentLang || localStorage.getItem('hit2open_lang') || 'en';
  }

  setLanguage(lang: string): void {
    this.translateService.use(lang);
    localStorage.setItem('hit2open_lang', lang);
  }

  showPassword() {
    this.show_button = !this.show_button;
    this.show_eye = !this.show_eye;
  }

  onLogin() {
    this.spinner.show();
    const payload: any = { ...this.form };
    if (this.requires2FA && this.totpCode) {
      payload.totpToken = this.totpCode;
    }

    this.service.postRequest(ApiUrl.adminLogin, payload).subscribe((resp: any) => {
      if (resp?.response?.data?.requires2FA) {
        this.requires2FA = true;
        this.spinner.hide();
        return;
      }
      const data = resp.response.data;
      localStorage.setItem('token', data.token);
      localStorage.setItem('role', data.role);
      localStorage.setItem('id', data.storeId);
      localStorage.setItem('managerId', data._id);
      if (data.chainId && Array.isArray(data.chainId) && data.chainId.length > 0) {
        localStorage.setItem('chainId', JSON.stringify(data.chainId));
      } else {
        localStorage.removeItem('chainId');
      }
      const role = data.role;
      if (role === 'receipt_auditor') {
        this.route.navigate(['/auditor-orders']);
      } else if (role === 'chain_manager') {
        this.route.navigate(['/my-chains']);
      } else {
        this.route.navigate(['/dashboard']);
      }
      this.spinner.hide();
    }, (err) => {
      const msg = err.error?.message || err.error?.response?.message || 'Login failed';
      this.toastr.error(msg);
      this.totpCode = '';
      this.spinner.hide();
    });
  }

  onTotpInput() {
    if (this.totpCode.length === 6) {
      this.onLogin();
    }
  }

  backToLogin() {
    this.requires2FA = false;
    this.totpCode = '';
  }
}
